module.exports = __webpack_public_path__ + "img/case46.78060bab.png";